import { render, staticRenderFns } from "./upload-cover.vue?vue&type=template&id=fc7e42b6&"
import script from "./upload-cover.vue?vue&type=script&lang=js&"
export * from "./upload-cover.vue?vue&type=script&lang=js&"
import style0 from "./upload-cover.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports